package gr.tech.meetinggenie.models.api

import kotlinx.serialization.Serializable

@Serializable
data class ApiResponse<T>(
    val success: Boolean,
    val message: String = "",
    val data: T? = null,
    val error: ApiError? = null
)

@Serializable
data class ApiError(
    val code: String,
    val message: String
)

fun <T> respondApiSuccess(message: String = "", data: T? = null) =
    ApiResponse(success = true, message = message, data = data)

fun respondApiError(code: String, message: String) =
    ApiResponse<Unit>(success = false, error = ApiError(code, message))
